const FDCategories = [
    "Coffee Tables",
    "Desks & Dinning tables",
    "Chairs",
    "Armchairs, Sofa & Benches",
    "Sideboards, Shelves & Consoles",
    "Mirrors, Screens, Carpets & Flooring",
    "Table Lamps",
    "Floor Lamps, Ceiling & Wall Lights",
    //"Vases & Accessories", // "Accessories",
    "Accessories",
    "Industrial Design",
    //"Limited Edition", // à supprimer
    //"Full Collection", // "Collections"
    //"Hotels & Resorts", // "Hotels & Restaurants"
    //"Private Villas", // "Private Residences"
    //"Private Apartments", // "Private Residences"
    //"Restaurants", // "Hotels & Restaurants"
    //"Retail", // "Retail & Offices"
    //"Scenography", // "Scenography & Installation"
    //"Installation", // "Scenography & Installation"
    "Collections",
    "Hotels & Restaurants",
    "Private Residences",
    "Retail & Offices",
    "Scenography & Installation",
    "Architecture, Town Planning & Transportation"
]

export default FDCategories;



/*

Catégories actuelles :
 
Coffee tables
Desks & dinning tables
Chairs
Armchairs, sofa & benches
Sideboards, shelves & consoles
Mirrors, screens, carpets & flooring
Table lamps
Floor lamps, ceilling & wall lights
Vases & accessories
Industrial design
Limited collection
Full collection
Hotels & resorts
Private villas
Private apartments
Restaurants
Retail
Scenography
Installation
Architecture, town planning & transportation
 
Nouveaux noms :
 
Coffee tables
Desks & dinning tables
Chairs
Armchairs, sofa & benches
Sideboards, shelves & consoles
Mirrors, screens, carpets & flooring
Table lamps
Floor lamps, ceilling & wall lights
Vases & accessories à Accessories
Industrial design
Limited collection à à supprimer
Full collection à Collections
Hotels & resorts à Hotels & restaurants
Private villas à Private residences
Private apartments à Private residences
Restaurants à Hotels & restaurants
Retail à Retail & offices
Scenography à Scenography & installation
Installation à Scenography & installation
Architecture, town planning & transportation

*/